var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wm-introduction-box border_box"},[_c('img',{attrs:{"src":_vm.imginfo,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }